import { AxiosResponse } from 'axios';
import { ShopDataField } from '../types';

export class DataFieldsMapper {
  static mapDataFields({ data }: AxiosResponse): ShopDataField[] {
    return data.dataFields;
  }
}
